import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

import { InvitationAccessLevel, InvitationStatusType } from '@vi-iot/client';

import { AuthStore, FetchedPartnerAccessInvitation } from '@store';
import { TranslateService } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-partner-access-settings-item',
  templateUrl: './partner-access-settings-item.component.html',
  styleUrls: ['./partner-access-settings-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerAccessSettingsItemComponent implements AfterViewInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  @Input() invitation: FetchedPartnerAccessInvitation;
  @Output() deleteInvitation = new EventEmitter<void>();
  @Output() hideInvitation = new EventEmitter<void>();
  readonly InvitationStatusType = InvitationStatusType;

  constructor(
    public authStore: AuthStore,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    // Required for matTooltipDisabled to work properly.
    this.cdr.detectChanges();
  }

  getTitle(): string {
    const accessLevel = this.invitation.accessLevel;

    switch (accessLevel) {
      case InvitationAccessLevel.Partner:
        return (
          this.invitation.companyName ??
          this.translate.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.COMPANY_PILE'
          )
        );
      case InvitationAccessLevel.Consumer:
        return (
          this.invitation.userName ??
          this.translate.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.COMPANY_CONSUMER'
          )
        );
    }
  }
}
